import { axiosClientV2 } from './axios.client';

/** Webhook and schedule triggers for a V2 flow (server/routes/v2/triggers.route.js). */
const failure = (err, fallback) => err?.message || fallback;

export async function listFlowTriggers(flowId) {
  try {
    const data = await axiosClientV2.get('triggers', { params: { flowId } });
    return { triggers: data?.triggers || [], error: null };
  } catch (err) {
    return { triggers: [], error: failure(err, 'Failed to load triggers') };
  }
}

export async function createFlowTrigger(body) {
  try {
    const data = await axiosClientV2.post('triggers', body);
    return { trigger: data?.trigger || null, webhookPath: data?.webhookPath || null, error: null };
  } catch (err) {
    return { trigger: null, webhookPath: null, error: failure(err, 'Failed to create trigger') };
  }
}

export async function updateFlowTrigger(id, body) {
  try {
    const data = await axiosClientV2.patch(`triggers/${id}`, body);
    return { trigger: data?.trigger || null, error: null };
  } catch (err) {
    return { trigger: null, error: failure(err, 'Failed to update trigger') };
  }
}

export async function deleteFlowTrigger(id) {
  try {
    await axiosClientV2.delete(`triggers/${id}`);
    return { error: null };
  } catch (err) {
    return { error: failure(err, 'Failed to delete trigger') };
  }
}

export async function runFlowTriggerNow(id) {
  try {
    const data = await axiosClientV2.post(`triggers/${id}/run`, {}, { timeout: 320000 });
    return { run: data?.run || null, trigger: data?.trigger || null, error: null };
  } catch (err) {
    return { run: null, trigger: null, error: failure(err, 'Run failed') };
  }
}

/** Absolute URL for a webhook path returned once at creation. */
export function webhookUrl(path) {
  if (!path) return '';
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${path}`;
}
